import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('deviceEventCurrent', [
    'cachedEventCurrents',
    'cachedEventCurrentsWithFilters',
  ]),
}

export const Methods = mapActions('deviceEventCurrent', ['fetchEventCurrents'])
